export const setOpacity = (color: string, opacity: number) => {
	if (color.startsWith("#")) {
		const bigint = Number.parseInt(color.replace("#", ""), 16);
		const r = (bigint >> 16) & 255;
		const g = (bigint >> 8) & 255;
		const b = bigint & 255;
		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	const match = color.match(/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/);
	if (!match) {
		throw new Error("Invalid color format");
	}
	const [_, r, g, b] = match;
	const alpha = Math.max(0, Math.min(100, opacity));
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
